var elem = document.querySelector('#flickity');
var videos = elem.getElementsByTagName('video');
var videosLength = videos.length;
console.log(videosLength);
var flkty = new Flickity( elem, {
  // options
  cellAlign: 'left',
  contain: true,
  wrapAround:true,
    autoPlay:false,
  fullscreen: true, 
    contain: true,
    draggable: false, 
    pageDots: false,
    on: {
      ready: function() {
        console.log('Flickity ready');
        videos[0].play();
      },
      change: function( index ) {
      console.log( 'Slide changed to' + videosLength );
    for(let i = 0;i < videosLength; i++){
      videos[i].currentTime = 0;
      videos[index].play();
    } 
    }
    }
  
});


// Create fullscreen video button
// var player = document.querySelector('.background-video');
// var video = player.getElementsByTagName('video');
// var fullscreen = player.querySelector('.fullscreen-btn');
function toggleFullscreen(button) {
  console.log('click');
  
  var video = button.nextElementSibling;
  video.classList.add("active");
  console.log(video);
	if(video.requestFullScreen){
		video.requestFullScreen();
	} else if(video.webkitRequestFullScreen){
		video.webkitRequestFullScreen();
	} else if(video.mozRequestFullScreen){
		video.mozRequestFullScreen();
	}
}
// fullscreen.addEventListener('click', toggleFullscreen);




// image full screen
var modal = document.getElementById('myModal');
function zoomFunction(){
  console.log(event.target.getAttribute('src'));
  let src= event.target.getAttribute('src');
  document.querySelector('#modalImage').setAttribute('src',src);
  document.getElementById('myModal').style.display = "block";
  document.querySelector('body').classList.add('ovarflowHidden');
}
// When the user clicks on <span> (x), close the modal
function zoomOutFunction() {
  console.log(event.target);
     document.querySelector('#modalImage').className += " out";
    setTimeout(function() {
       document.getElementById('myModal').style.display = "none";
        document.querySelector('#modalImage').className = "modal-content";
      document.querySelector('body').classList.remove('ovarflowHidden');
     }, 400);
    
 }    


